export default __webpack_public_path__ + "static/media/buddy.4c659789.png";